import Bar from '@/components/report/content/Bar'
import Chapter from '@/components/report/content/Chapter'
import Cluster from '@/components/report/content/Cluster'
import Pie from '@/components/report/content/Pie'
import PlainText from '@/components/report/content/PlainText'
import Scatter from '@/components/report/content/Scatter'
import Venn from '@/components/report/content/Venn'
import Vid from '@/components/report/content/Vid'
import VidSwitcher from '@/components/report/content/VidSwitcher'
import GraphHeader from '@/components/report/content/GraphHeader'
import Adobot from '@/components/report/Adobot'
import MobileMoment from '@/components/report/content/MobileMoment'
import StateMixin from '@/components/report/mixins/StateMixin'
import { industryTypes } from '@/lib/consts'

export default {
  mixins: [ StateMixin ],
  props: {
    data: { type: Object, required: true },
    bg: { type: String, required: true },
    demoBot: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      activeIdx: 0,
      dataOverride: null,
      indOverride: null,
      botActive: false,
      botHeld: false,
      demoActive: false,
      graphTypes: [
        'Bar',
        'Cluster',
        'Pie',
        'Venn'
      ]
    }
  },
  computed: {
    contentData () {
      return this.dataOverride || this.data.slides[ this.activeIdx ]
    },
    sub () {
      return this.contentData.sub
    },
    bot () {
      return this.data.hasOwnProperty( 'bot' ) ? this.data.bot : ''
    },
    wrapClasses () {
      return {
        'has-bot': this.bot,
        'align-items-stretch': !this.isIE,
        'align-items-center': this.isIE
      }
    }
  },
  methods: {
    botOn () {
      this.botHeld = true
      switch ( true ) {
        case (typeof this.bot === 'object'):
          this.dataOverride = Object.assign( {}, this.data.slides[ this.activeIdx ], this.bot.slides[ this.activeIdx ] )
          break
        case (this.bot.includes( 'industry' )):
          this.indOverride = Object.values( industryTypes ).find( obj => obj.id !== this.industry ).id
          break
        default:
          this.$refs.content.$emit( this.bot )
      }
    },
    botOff () {
      this.botHeld = false
      this.dataOverride = this.indOverride = null
      this.$refs.content.$emit( 'botOff' )
    },
    toggleInd () {
      this.indOverride = this.industry === industryTypes.mktg.id ? industryTypes.it.id : industryTypes.mktg.id
    }
  },
  components: {
    Bar,
    Chapter,
    Cluster,
    Pie,
    PlainText,
    Venn,
    Vid,
    GraphHeader,
    Scatter,
    Adobot,
    MobileMoment,
    VidSwitcher
  }
}



// WEBPACK FOOTER //
// ./src/components/report/mixins/ContentWrapMixin.js